const getActiveModifierKeys = (event) => {
  if ("getModifierState" in event) return {
    meta: event.getModifierState("Meta"),
    shift: event.getModifierState("Shift"),
    alt: event.getModifierState("Alt"),
    ctrl: event.getModifierState("Control")
  };
  return {
    meta: event.metaKey,
    shift: event.shiftKey,
    alt: event.altKey,
    ctrl: event.ctrlKey
  };
};

export { getActiveModifierKeys };
//# sourceMappingURL=getActiveModifierKeys.js.map
